import { getRouteApi } from "@tanstack/react-router"


export function useProjects() {
  return getRouteApi("/$orgId/").useLoaderData().projects
}

export function useFavoriteProjects() {
  return getRouteApi("/$orgId/").useLoaderData().favoriteProjects
}